import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const TefImportFileRequest = (userId, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}TefInternal/ImportFile`,
		params: { userId },
		data: formData,
		hasLoading: true,
	});
};

export const TefGetLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}TefInternal/GetLastUpdate`,
	hasLoading: true,
});

export const TefGenerateResultRequest = (userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}TefInternal/GenerateResult`,
	params: { userId },
	hasLoading: true,
});

export const TefSendEmailsRequest = (userId, userEmail, testEmails, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}TefInternal/SendEmails`,
		params: { userId, userEmail, testEmails },
		data: formData,
		hasLoading: true,
	});
};

export const TefGetExtensionsHistoryRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}TefInternal/GetExtensionsHistory`,
	params: { userId },
	hasLoading: true,
});

export const RepoImportRequest = (userId, module, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}FilesStorage/Import`,
		params: { userId, module },
		data: formData,
		hasLoading: true,
	});
};

export const RepoGetLastUpdateRequest = (module) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FilesStorage/GetLastUpdate`,
	params: { module },
	hasLoading: true,
});

export const RepoExportRequest = (userId, module) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FilesStorage/Export`,
	params: { userId, module },
	hasLoading: true,
});